import * as React from 'react';
import styled from "styled-components";

interface CardProps {
  number: number;
  title: string;
  description?: string;
}

export const Container = styled.div`
  display: grid;
  grid-template-columns: max-content 220px;
  gap: 14px;
  padding: 20px;
  width: 100%;
  max-width: 360px;
  min-height: 152px;
  box-sizing: border-box;
  background: #414143;
  border-radius: 20px;
`;

const Number = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 50%;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
`

const Description = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 20px;
`

/**
 * render landing page tariffs section card
 * @constructor
 */
export default function Card(props: CardProps): React.ReactElement {
  return (
    <Container>
      <Number>{props.number}</Number>
      <div>
        <Title>{props.title}</Title>
        <Description>{props.description}</Description>
      </div>
    </Container>
  );
}
